import {NotificationBase} from "./notification-base";

export class NotificationLinkbox extends NotificationBase {


    hasLinks()
    {
        return this.notification.additionalFields?.links > 0;
    }

    getFirstLink()
    {
        return this.notification.additionalFields?.links[0] ?? null;
    }

}
